
import { getCookie } from '../utils/cookie';

export default async ({ store, route, redirect }) => {
  // Flag to track if middleware is triggering a redirect
  let isRedirecting = false;

  // RK/NOTE/29-07-2019
  //
  // For now, any routes that do not require authentication need to
  // be hard-coded here because the default Layout automatically
  // attempts authentication and redirects to login page on failure.
  // TODO later: draft a simpler way to differentiate authenticated
  // pages with unauthenticated pages.
  //
  // The other issue is that for routes that don't need authentication
  // seem to be created/mounted twice. Not sure why this is the case,
  // it may be vuex recreating components based on a dispatch
  if (store.getters['auth/userPromoterOid'] === null && !store.getters['auth/isAuthenticated']) {
    if (
      route.path !== '/authenticate/login'
      && route.path !== '/authenticate/masquerade-login'
      && route.path !== '/authenticate/signup'
      && route.path !== '/authenticate/forgot-password'
      && route.path !== '/authenticate/reset-password'
      && route.path !== '/authenticate/email-verify'
      && route.path !== '/authenticate/invite'
      && route.path !== '/authenticate/invite-expired'
      && route.path !== '/authenticate/invite-sent'
      && route.path !== '/maintenance'
    ) {
      isRedirecting = true;
      redirect('/authenticate/login');
      return;
    }
  } else if (store.getters['auth/userPromoterOid'] === null && store.getters['auth/isAuthenticated']) {
    // If there is no promoter account then we need to populate it, otherwise don't.
    // Check for token existence before trying to verify to avoid infinite loops
    const token = getCookie('x-auth-token') || window.sessionStorage.getItem('x-auth-token');
    if (token) {
      await store.dispatch('auth/VERIFY_TOKEN');
    } else {
      // No token but isAuthenticated returned true, clear any stale state
      store.dispatch('auth/LOGOUT');
    }
  } else {
    // Do nothing if promoter oid exists
  }
  
  // Signal middleware completion if not redirecting
  if (process.client && !isRedirecting && typeof window !== 'undefined' && window.__resolveMiddlewarePromise) {
    // Use setTimeout to ensure this runs after the middleware completes
    setTimeout(() => {
      window.__resolveMiddlewarePromise();
      console.log('Auth middleware completed');
    }, 0);
  }
};
